<template>
  <div class="logo">
    <img class="img-fluid d-block w-100" :src="logo" />
  </div>
</template>

<script>
export default {
  name: 'Logo',
  props: {
    logo: {
      type: String,
    },
  },
};
</script>

<style></style>
